/* global angular */
( function () {
	/* eslint-disable max-params */
	'use strict';

	/* eslint-disable max-params */
	function Preview ( logger, apiService, Session, $routeParams, $modal, $location, TITLE, moment, _, $window, $timeout, $rootScope, authService, observationService, TOOLTIP_MESSAGES, $filter, $q, $sce ) {
		/* eslint-enable max-params */
		var self = this;

		self.title          = TITLE.obsPreview;
		self.data           = null;
		self.btnCaption     = null;
		self.collapseHeader = true;
		self.printLoading   = false;
		self.isScore        = false;
		self.userId         = Session.getCredentials().PersonnelId;

		self.poolNav = 'evidences';
		self.tooltip = TOOLTIP_MESSAGES;

		self.startDate   = moment().format();
		self.credentials = Session.getCredentials();

		function redirectToEdit () {
			$location.path( '/observations/' + $routeParams.id  + '/edit' );
		}

		function getGroups ( groupsData ) {
			$rootScope.$broadcast( 'obs:get:groups', groupsData );
		}

		function setScore () {
			if ( self.data.hasOwnProperty( 'score' ) ) {
				self.isScore    = true;
				self.data.score = $filter( 'number' )( self.data.score, 2 );
			}
		}

		function setNames () {
			self.observeeName = self.data.observee.lastName + ', ' +  self.data.observee.firstName;
			self.observerName = self.data.observer.lastName + ', ' +  self.data.observer.firstName;
		}

		function getCleanCopySig () {
			return angular.copy( self.data.digitalSignature ) || {};
		}

		function returnUserSig ( sig ) {
			return sig.userId === self.userId;
		}

		function getNamesOfSigUsers ( pds ) {
			var list   = [];
			var status = [ 'Unsigned', 'Signed' ];

			self.sigStatusList = 'Loading...';

			function getSigPd ( item ) {
				return item.type === 4;
			}

			function formatData ( item, index ) {
				return '<tr><td class="text-left"><div style="max-width:230px">' + item.data.FirstName + ' ' + item.data.LastName + '</div></td>'
					+ '<td>&emsp;-&emsp;</td><td class="text-right">' + list[ index ] + '</td></tr>';
			}

			var users = pds.filter( getSigPd ).map( function ( item ) {
				list.push( status[ Number( Boolean( item.completedDate ) ) ] );
				return apiService.userDetails( item.pdOwner || self.originalData.observee.id );
			} );

			$q.all( users ).then( function ( res ) {
				self.sigStatusList = $sce.trustAsHtml( '<table>' + res.map( formatData ).join( '' ) + '</table>' );
			} );
		}

		function getObservation () {
			self.loadingObs = true;

			apiService.observation.get( {
				'observationId' : $routeParams.id,
				'userId'        : Session.getCredentials().userId,
				'observation'   : 'observations'
			}, function ( rawdata ) {
				// redirect to perform obs page if observation is in progress and not an in review observation
				if ( rawdata.partialSubmission && !rawdata.inReview ) {
					redirectToEdit();
				}

				self.data = observationService.denormalize( rawdata );

				setNames();
				setScore();
				getGroups( self.data.template.groups );

				self.loadingObs        = false;
				self.hasObserveeSigned = observationService.getValidSignature( getCleanCopySig().observee );
				self.hasSelfSigned     = observationService.getValidSignature( ( getCleanCopySig().reviewers || [] ).filter( returnUserSig ) );
				self.originalData      = angular.copy( self.data );

				getNamesOfSigUsers( angular.extend( [], self.data.masterPrescribedResources ) );
			}, function () {
				$location.path( '/observations' );
				logger.notifyErrorPath( '/observations/' + $routeParams.id );
				logger.error( 'Unable to fetch.', ''  );
			} );
		}

		function validateTemplate () {
			self.data.template.creator = _.pick( self.data.template.creator, 'id' );

			self.data.template.groups.map( function ( group ) {
				delete group.index;
			} );
		}

		function toggleModal () {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/observations/observation-preview/edit-confirmation.html',
				'controller'   : 'EditConfirmationController',
				'controllerAs' : 'vm',
				'size'         : 'lg'
			} );

			modalInstance.result.then( function () {
				self.generateVersion();
			} );
		}

		function generateVersion () {
			var newName  = self.data.name + ' (copy:' + moment( self.startDate ).format( 'MM/DD/YY' ) + ')';

			validateTemplate();

			// TODO: send type when API is ready
			// check if eSignature is to be included
			var params = {
				'id'                : apiService.generateUUID(),
				'name'              : newName,
				'observee'          : _.pick( self.data.observee, 'id' ),
				'observer'          : _.pick( self.data.observer, 'id' ),
				'location'          : _.pick( self.data.location, 'observeeClientId' ),
				'partialSubmission' : true,
				'startDate'         : self.data.startDate,
				'endDate'           : self.data.endDate,
				'evidences'         : self.data.evidences,
				'template'          : self.data.template,
				'tags'              : self.data.tags
			};

			apiService.observation
				.save( {
					'userId'      : self.credentials.userId,
					'observation' : 'observations'
				}, params )
				.$promise.then( function ( res ) {
					var url = '/observations/' + res.id + '/edit';

					$location.path( url );
				} );
		}

		function printThis () {
			$timeout( function () {
				self.printLoading = false;
			}, 500 ).then( function () {
				$timeout( function () {
					$window.print();
				}, 500 );
			} );
		}

		function printLoad ( status ) {
			self.printLoading = status;
		}

		function updatePrintOptions () {
			printLoad( true, printThis() );
		}

		function openGroupScore ( group ) {
			$modal.open( {
				'templateUrl'  : '/templates/components/evidences/pool/pool-group/group-score-modal.html',
				'controller'   : 'groupScoreCtrl',
				'controllerAs' : 'vm',
				'resolve'      : {
					'group' : function () {
						return group;
					},

					'scoreLoading' : function () {
						return undefined;
					}
				}
			} );
		}

		function openObsScore () {
			$modal.open( {
				'templateUrl'  : '/templates/components/score/obs-score.html',
				'controller'   : 'ObsScoreController',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'windowClass'  : 'obs-score-modal',
				'resolve'      : {
					'score' : function () {
						return self.data.score;
					},

					'manualScore' : function () {
						return undefined;
					}
				}
			} );
		}

		function userCanSubmitFeedback ( observationId ) {
			if ( self.feedbackEnabled === undefined ) {
				var userId = Session.getCredentials().userId;

				apiService.getUsersThatCanProvideFeedback( observationId ).then(
					function ( res ) {
						self.feedbackEnabled = _.contains( res.data.data, userId.toString() );
					}
				);
			}
		}

		function activate () {
			if ( $routeParams.id === 'undefined' ) {
				$location.url( '/observations' );
			} else {
				userCanSubmitFeedback( $routeParams.id );
				getObservation();
			}
			logger.info( 'observation preview used' );
		}

		function getProficiency ( group ) {
			var proficiencyTitle = null;

			var nullTitle = {
				'title' : ''
			};

			group.rubric.forEach( function ( proficiency ) {
				if ( group.score > proficiency.minRange && group.score <= proficiency.maxRange ) {
					proficiencyTitle = proficiency.title;
				}
			} );
			return proficiencyTitle || ( group.rubric[ group.rubric.length - 1 ] || nullTitle ).title;
		}

		function isValidScore ( score ) {
			return angular.isNumber( score );
		}

		function showSignatureModal () {
			$modal.open( {
				'templateUrl'  : '/templates/observations/signature-modal/signature-modal.html',
				'controller'   : 'signatureModalCtrl',
				'controllerAs' : 'sig',
				'windowClass'  : '',
				'resolve'      : {
					'obs' : function () {
						return self.data;
					},
					// we don't need this as we are using a different api
					'submitFn' : angular.noop,

					'parentController' : function () {
						return self;
					},

					'submitStatus' : function () {
						return '';
					}
				}
			} );
		}

		function userHasPD () {
			function getUserDigitalSigPD ( pd ) {
				return pd.type === 4 && Number( pd.pdOwner ) === Number( self.userId ) || self.data.observee.id === self.userId && !pd.pdOwner;
			}

			return angular.extend( [], self.data.masterPrescribedResources ).some( getUserDigitalSigPD );
		}

		self.generateVersion          = generateVersion;
		self.getProficiency           = getProficiency;
		self.toggleModal              = toggleModal;
		self.updatePrintOptions       = updatePrintOptions;
		self.openGroupScore           = openGroupScore;
		self.openObsScore             = openObsScore;
		self.isViewOnlyMode           = authService.isViewOnlyMode();
		self.isValidScore             = isValidScore;
		self.redirectToEdit           = redirectToEdit;
		self.showSignatureModal       = showSignatureModal;
		self.checkIfSignatureComplete = observationService.checkIfSignatureComplete;
		self.userHasPD                = userHasPD;

		activate();
	}

	angular
		.module( 'app.observations' )
		.controller( 'PreviewObservation', Preview );

	Preview.$inject = [ 'logger', 'apiService', 'Session', '$routeParams', '$modal', '$location', 'TITLE', 'moment', '_', '$window', '$timeout', '$rootScope', 'authService', 'observationService', 'TOOLTIP_MESSAGES', '$filter', '$q', '$sce' ];
} )( );
